export default __webpack_public_path__ + "static/commercial_b.950c1c31594e2e1a5701a23d7a836209.png";